import React from "react";
import icons from "../../../assets/images/constantIcons";
import images from "../../../assets/images/constantImages";

const plans = [
  {
    name: "Basic",
    price: "₹500",
    features: [
      "Lorem Ipsum is simply dummy",
      "Lorem Ipsum is simply",
      "Lorem Ipsum is simply dummy",
      "Lorem Ipsum",
    ],
  },
  {
    name: "Standard",
    price: "₹800",
    features: [
      "Lorem Ipsum is simply dummy",
      "Lorem Ipsum is simply",
      "Lorem Ipsum is simply",
      "Lorem Ipsum",
    ],
  },
  {
    name: "Premium",
    price: "₹1100",
    features: [
      "Lorem Ipsum is simply dummy",
      "Lorem Ipsum is simply",
      "Lorem Ipsum is simply",
      "Lorem Ipsum",
    ],
  },
];

const SubscriptionPlan = () => {
  return (
    <div className="w-full flex flex-col my-5 md:my-8 px-5">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {plans.map((plan, index) => (
          <div
            key={index}
            className="border border-[#92D6A5] rounded-2xl py-6 px-4 shadow-lg bg-green50 hover:bg-[#92D6A5] "
          >
            <div className="flex items-center space-x-4 mb-6">
              <div className="w-[64px] h-[64px] bg-green700 rounded-xl">
                <img src={images.subscriptionimg} alt="subscriptionimg" className=""/>
              </div>
              <div className="flex flex-col">
                <h3 className="text-base font-semibold text-G500 mb-1">
                  {plan.name}
                </h3>
                <p className="text-2xl font-semibold text-Grey700">
                  {plan.price}
                </p>
              </div>
            </div>
            <hr className="bg-G30 w-full"/>
            <ul className="my-6 space-y-2">
              {plan.features.map((feature, i) => (
                <li key={i} className="flex items-start space-x-1 text-sm">
                  <icons.IoIosCheckmark className="text-green700 text-xl" />
                  <span className="text-sm text-G300">{feature}</span>
                </li>
              ))}
            </ul>
            <button className="w-full bg-white border border-green text-green text-base font-medium py-2 rounded-lg flex justify-center items-center space-x-2 mt-12">
              <span>Choose Plan</span>
              <span><icons.FaArrowRightLong/></span>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubscriptionPlan;
